// Leaflets settings: the defaults for new jobs, who distributors contact, and
// the delivery guidelines shown in their app and printed on route sheets.
import { useState } from 'react';
import { api } from '../lib/auth';
import { Button, Input, Textarea, ModalShell } from '../lib/ui';
import { APP_URL } from '../lib/leaflets';
import { Label, errorText } from './TradeCommon';

export default function LeafletsSettings({ settings, onClose, onSaved }) {
  const [f, setF] = useState(() => ({
    ratePer1000: settings?.ratePer1000 ?? '',
    leaflet: settings?.leaflet || '',
    contactName: settings?.contactName || '',
    contactPhone: settings?.contactPhone || '',
    guidelines: settings?.guidelines || '',
  }));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const set = (k) => (e) => setF(p => ({ ...p, [k]: e.target.value }));

  const save = async () => {
    setSaving(true);
    setError('');
    try {
      const { data } = await api.put('/leaflets/admin/settings', f);
      onSaved(data.settings);
    } catch (e) {
      setError(errorText(e));
      setSaving(false);
    }
  };

  return (
    <ModalShell onClose={onClose} width={640} ariaLabel="Leaflets settings">
      <h2 style={{ margin: '0 0 6px', fontSize: 18 }}>Leaflets settings</h2>
      <p className="lf-muted" style={{ marginBottom: 14 }}>
        Distributors use the app at <a href={APP_URL} target="_blank" rel="noreferrer">{APP_URL.replace('https://', '')}</a> with the login made for them under People.
      </p>
      <div className="trade-form">
        <h4>New jobs</h4>
        <div className="inv-grid2">
          <div>
            <Label hint="£ per 1000 delivered">Default pay</Label>
            <div className="pl-price"><Input type="number" min="0" step="0.5" value={f.ratePer1000} onChange={set('ratePer1000')} placeholder="e.g. 40" /></div>
          </div>
          <div><Label hint="the design being handed out">Leaflet</Label><Input value={f.leaflet} onChange={set('leaflet')} placeholder="e.g. Evergreen" /></div>
        </div>
        <div className="trade-form__hint">Approved rounds go into the Insights flier log under the job's leaflet name.</div>

        <h4>In the app and on route sheets</h4>
        <div className="inv-grid2">
          <div><Label hint="who they ask">Contact name</Label><Input value={f.contactName} onChange={set('contactName')} placeholder="e.g. Michael" /></div>
          <div><Label hint="calls, texts or WhatsApp">Contact phone</Label><Input type="tel" value={f.contactPhone} onChange={set('contactPhone')} /></div>
        </div>
        <div>
          <Label hint='"- " starts a bullet; any other line is a heading'>Delivery guidelines</Label>
          <Textarea rows={12} value={f.guidelines} onChange={set('guidelines')} />
          <div className="trade-form__hint">Empty it and save to go back to the standard guidelines.</div>
        </div>
        {error && <div className="ui-banner ui-banner--bad">{error}</div>}
      </div>
      <div className="trade-form__actions">
        <Button variant="muted" onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={save} disabled={saving}>{saving ? 'Saving…' : 'Save'}</Button>
      </div>
    </ModalShell>
  );
}
